export default __webpack_public_path__ + "static/media/Hooves of the Warded Brute.4bcd0878.jpg";